import { PostHogProvider as PostHogReactProvider } from "posthog-js/react";
import { ReactNode } from "react";

type PostHogProviderProps = {
  children: ReactNode;
};

export default function PostHogProvider({ children }: PostHogProviderProps) {
  const postHog = {
    host: import.meta.env.PUBLIC_POSTHOG_HOST,
    key: import.meta.env.PUBLIC_POSTHOG_KEY,
  };
  const options = {
    api_host: postHog.host,
  };
  const production = import.meta.env.MODE === "production";
  if (production) {
    if (!postHog.host) {
      throw new Error("PostHog host is not set");
    } else if (!postHog.key) {
      throw new Error("PostHog key is not set");
    } else {
      console.log("PostHog environment variables are set");
    }
  }
  return production ? (
    <PostHogReactProvider options={options} apiKey={postHog.key}>
      {children}
    </PostHogReactProvider>
  ) : (
    children
  );
}
